import { render } from "./attendance-employee.vue?vue&type=template&id=0bd6ca8c"
import script from "./attendance-employee.vue?vue&type=script&lang=js"
export * from "./attendance-employee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__